import React, { useState, useEffect } from 'react'
import {
	CNav, CNavItem, CCard, CRow, CCol,
	CImage, CCardHeader, CCardTitle,
	CCardBody, CButton, CNavLink, CModal, CModalHeader, CModalBody,
	CModalFooter,
	CFormInput
} from 'compat/coreui';
import BusinessDashboard from './BusinessDashboard';
import BusinessMenu from './BusinessMenu';
import BusinessDeals from './BusinessDeals';
import ReviewSection from './ReviewSection';
import PhotosSections from './PhotosSections';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getData } from '../helpers/api';
import "react-responsive-carousel/lib/styles/carousel.min.css";
var Carousel = require('react-responsive-carousel').Carousel;

export default function BusinessPageNew(props) {
	const token = localStorage.getItem('token');
	const [compCard, setCompCard] = useState('menu');
	const [bizId, setBizId] = useState('');
	const [sellerData, setSellerData] = useState({});
	const [follow, setFollow] = useState(true);
	const [modal, setModal] = useState(false);

	const location = useLocation();
	const dispatch = useDispatch();
	// const user = useSelector(state => state.user);

	const [cartData, setCartData] = useState([])
	const mytoken = localStorage.getItem('token');
	const orderDetails = localStorage.getItem('myProduct');

	let items = useSelector(state => state.products)

	useEffect(() => {
		const path = location.pathname.split('/')[2];
		setBizId(path);
		getBizDetails(path);
		getFollowers();
		if (orderDetails) {
			setCartData(JSON.parse(orderDetails))
		}

	}, [])
	const openModel = () => {
		console.log('---------------', modal);
		setModal(true)
		console.log('---------------', modal);
	}
	const submitNo = () => {
		window.location.replace("http://google.com/");
	}
	let totalPrice = 0
	if (items.length > 0) {
		items.map(item => {
			let p = item.productDetails[item.priceType]
			totalPrice = totalPrice + parseFloat(p) * item.quantity
		})
	}

	const placeOrder = (e) => {
		e.preventDefault();
		let cdata = cartData.slice().map(product => {
			product.productDetails = undefined
			return product
		});

		axios({
			url: `${process.env.REACT_APP_APP_API_URL}/api/order`,
			method: 'POST',
			headers: {
				'Authorization': 'Bearer ' + mytoken
			},
			data: {
				products: cdata
			}
		}).then(response => {
			if (response.data.status) {
				localStorage.removeItem('myProduct');
				setCartData([]);
				toast.success('Ordered successfully');
			}
		}).catch(console.log)
	}

	const removeItem = (id) => {
		let arr = [...items];
		arr.splice(id, 1);
		setCartData(arr);
		if (arr.length === 0) {
			dispatch({ type: 'UPDATE_PRODUCT', data: arr })
			localStorage.setItem('myproduct', '[]');
		} else {
			dispatch({ type: 'UPDATE_PRODUCT', data: arr })
			const newData = JSON.stringify(arr)
			localStorage.setItem('myProduct', newData);
		}
	}
	const goBack = () => {
		window.history.back();
	}

	const getFollowers = () => {
		getData(`${process.env.REACT_APP_APP_API_URL}/api/follow`).then(res => {
			if (res.data.status) {
				const path = location.pathname.split('/')[2];
				res.data.following.forEach(d => {
					let fid = d.following
					if (fid._id === path) {
						setFollow(false);
					}
				});
			}
		}).catch(console.log)
	}



	const getBizDetails = (path) => {
		axios({
			url: `${process.env.REACT_APP_APP_API_URL}/api/seller/${path}`,
			method: 'GET',
			headers: {
				'Authorization': 'Bearer ' + token
			},
		}).then(response => {
			if (response.data.status) {
				setSellerData(response.data.sellers[0]);
			}
		}).catch(console.log)
	}


	const followerHandler = () => {
		const data = {
			"seller": bizId
		}
		axios({
			url: `${process.env.REACT_APP_APP_API_URL}/api/follow`,
			method: 'POST',
			headers: {
				'Authorization': 'Bearer ' + token
			},
			data,
		}).then(response => {
			if (response.data.status) {
				setFollow(false)
				toast.success('Followed successfully')
			}
		}).catch(console.log)
	}

	const unfollow = (id) => {
		axios({
			url: `${process.env.REACT_APP_APP_API_URL}/api/unfollow`,
			method: 'POST',
			headers: {
				'Authorization': 'Bearer ' + token
			},
			data: { "seller": id }
		}).then(response => {
			if (response.data.status) {
				setFollow(true)
				toast.success('Unfollowed successfully')
			}
		}).catch(console.log)
	}
	return (
		<React.Fragment style={{ padding: "0px" }}>
			<CModal
				show={modal}
			>
				<CModalHeader>Compose Message</CModalHeader>
				<CModalBody>
					<CCol className="text-center">
						<CCol>
							<CFormInput style={{ marginLeft: "10px", marginRight: "10px" }} placeholder="Enter a subject"></CFormInput>
							<CFormInput style={{ height: "100px", margin: "10px" }} placeholder="Enter a message"></CFormInput>
						</CCol>
						<CRow >
							<CButton style={{ background: "#FF5F1F", color: "white", width: "100%", marginLeft: "40px", marginRight: "40px" }} onClick={() => submitNo()}>NO</CButton>
						</CRow>
						<CCol>
							<h4>Joint Plug strives to abide by all state laws and regulations in regards to access to cannabis.</h4>
						</CCol>
					</CCol>
				</CModalBody>
			</CModal>
			<Carousel autoPlay centerMode infiniteLoop stopOnHover showThumbs={false}>
				{(sellerData.promoImage) && sellerData.promoImage.map((item, index) => {
					return (
						<CImage style={{ height: "200px", minWidth: "120%" }} src={"https://pub-94bb2fa9f3f74a4d814557af59abaf7f.r2.dev/seller/" + item} />
					)
				})}

			</Carousel>
			<CRow>
				<CCol lg={12}>
					<div className="business-info-section-new">
						<div className="menus_business_details">
							<h1>{sellerData.businessName}</h1>
							<CRow style={{ marginLeft: "10px" }}>
								<i class="fa fa-map-marker menus_icon" aria-hidden="true"></i>
								<h4>{sellerData.city} | {sellerData.state}</h4>
								<i class="fa fa-phone-square menus_icon" aria-hidden="true"></i>
								<h4>{sellerData.ownerPhone} </h4>
							</CRow>
							<CRow style={{ marginLeft: "10px" }}>
								<CButton style={{ border: "solid", borderWidth: "1px" }}>4.3 <i class="fa fa-star-half-o" aria-hidden="true"></i></CButton>
								<h4>{sellerData.reviews ? sellerData.reviews.length : 0} Reviews</h4>
							</CRow>
						</div>
						<div>

							<CCardBody className="mb-0 pb-0 custom_nav" style={{ fontSize: "17px" }}>
								<CNav variant="tabs" color="success">
									<CNavItem>
										<span class="fa fa-bars icon"></span>
										<CNavLink active={compCard === 'menu'} onClick={() => setCompCard('menu')}>Menu</CNavLink>
									</CNavItem>
									<CNavItem>
										<span class="fa fa-home icon"></span>
										<CNavLink active={compCard === 'dashboard'} onClick={() => setCompCard('dashboard')}>Dashboard</CNavLink>
									</CNavItem>
									<CNavItem>
										<span class="fa fa-delicious icon"></span>
										<CNavLink active={compCard === 'deals'} onClick={() => setCompCard('deals')}>Deals</CNavLink>
									</CNavItem>
									<CNavItem>
										<span class="icon-heart icon"></span>
										<CNavLink active={compCard === 'reviews'} onClick={() => setCompCard('reviews')}>Reviews</CNavLink>
									</CNavItem>
									<CNavItem>
										<span class="fa fa-picture-o icon"></span>
										<CNavLink active={compCard === 'photos'} onClick={() => setCompCard('photos')}>Photos</CNavLink>
									</CNavItem>
									<CNavItem>
										<span class="fa fa-picture-o icon"></span>
										<CNavLink active={compCard === 'photos'} ><CImage src="/images/show_more.png"></CImage></CNavLink>
										<ul className="ul_list">
											<li><a href="#" class="about"><i class="fa fa-info-circle" aria-hidden="true"></i> About</a></li>
											<li onClick={() => openModel()} ><a class="contact"><i class="fa fa-envelope" aria-hidden="true"></i> Email Us</a></li>
											<li><a href="#" rel="nofollow" ><i class="fa fa-flag" aria-hidden="true"></i> Report</a></li>
											<li onClick={() => openModel()}><a class="contact" ><i class="fa fa-envelope" aria-hidden="true"></i> Message Business</a></li>
										</ul>
									</CNavItem>
									{/* <CNavItem>
								<CNavLink>:</CNavLink>
							  </CNavItem> */}
								</CNav>
							</CCardBody>
						</div>
						{compCard === "dashboard" && <BusinessDashboard seller={sellerData} />}
						{compCard === "menu" && <BusinessMenu seller={sellerData} />}
						{compCard === "deals" && <BusinessDeals seller={sellerData} />}
						{compCard === "reviews" && <ReviewSection seller={sellerData} />}
						{compCard === "photos" && <PhotosSections seller={sellerData} />}
					</div>
				</CCol>
			</CRow>
		</React.Fragment>
	)
}